const CART_COUNT_LABEL_SELECTOR = '[data-bb-cart-count-label]';
const CART_COUNT_BADGE_SELECTOR = '[data-bb-cart-count-badge]';
let lastRenderedCartCount = null;

function animateBrokenBlueprintCartBadge(element) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (element.bbBadgeTimer) window.clearTimeout(element.bbBadgeTimer);
  element.classList.remove('is-bumping');
  void element.offsetWidth;
  element.classList.add('is-bumping');

  element.bbBadgeTimer = window.setTimeout(() => {
    element.classList.remove('is-bumping');
    delete element.bbBadgeTimer;
  }, window.BBMotion?.tokens?.badge || 220);
}

function renderBrokenBlueprintCartCount(itemCount) {
  const count = Math.max(0, Number.parseInt(String(itemCount ?? 0), 10) || 0);
  const shouldAnimate = lastRenderedCartCount !== null && count !== lastRenderedCartCount;

  document.querySelectorAll(CART_COUNT_LABEL_SELECTOR).forEach((element) => {
    const label = element.dataset.bbCartLabel || 'BAG';
    element.textContent = `${label} (${count})`;
  });

  document.querySelectorAll(CART_COUNT_BADGE_SELECTOR).forEach((element) => {
    element.textContent = String(count);
    element.hidden = count === 0;
    if (shouldAnimate && count > 0) animateBrokenBlueprintCartBadge(element);
  });

  lastRenderedCartCount = count;
}

function syncFromNativeCartBubble() {
  const nativeCount = document.querySelector('.cart-bubble__text-count')?.textContent;
  if (nativeCount != null) renderBrokenBlueprintCartCount(nativeCount);
}

function seedFromRenderedBadge() {
  if (lastRenderedCartCount !== null) return;
  const renderedCount = document.querySelector(CART_COUNT_BADGE_SELECTOR)?.textContent;
  if (renderedCount == null) return;
  lastRenderedCartCount = Math.max(0, Number.parseInt(renderedCount, 10) || 0);
}

document.addEventListener('shopify:cart:lines-update', (event) => {
  event.promise
    ?.then(({ cart, detail }) => {
      const confirmedTotal = Number(cart?.totalQuantity);
      if (Number.isFinite(confirmedTotal)) {
        renderBrokenBlueprintCartCount(confirmedTotal);
        return;
      }

      // The action quantity is a delta, not an authoritative cart total.
      // Fetch only when the originating event did not already provide Shopify's
      // confirmed cart, avoiding the duplicate read on normal product adds.
      return syncFromCart();
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[bb-cart-count] Cart count update failed.', error);
    });
});

// Some theme cart mutations (including app/recommendation additions) refresh
// sections without a visible native bubble. A cart read after those mutations
// keeps the shared header badge tied to Shopify's total line quantity.
async function syncFromCart() {
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!response.ok) return;
    const cart = await response.json();
    renderBrokenBlueprintCartCount(cart?.item_count);
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('[bb-cart-count] Cart refresh failed.', error);
  }
}

window.addEventListener('pageshow', (event) => {
  syncFromNativeCartBubble();

  // Fresh document responses already render Shopify's authoritative cart
  // quantity in the header. Only a back/forward cache restore can retain a
  // stale server-rendered value, so avoid a redundant cart request on every
  // normal page load.
  if (event.persisted) void syncFromCart();
});
syncFromNativeCartBubble();
seedFromRenderedBadge();
